export default [
  {
    path: "/submitYayun", // 亚运宝贝表单提交
    component: resolve =>
      require(["@/pages/activity/yayun/submitYayun"], resolve),
    name: "简历填写"
  },
  {
    path: "/yaYunRecord", // 亚运宝贝提交记录
    component: resolve =>
      require(["@/pages/activity/yayun/yaYunRecord"], resolve),
    name: "提交记录"
  },
  {
    path: "/qrDownLoad", // 长龙航空二维码
    component: resolve => require(["@/pages/activity/qr"], resolve),
    name: "二维码"
  },
  {
    path: "/takeFreshVipQrCode", // 获取会员推广二维码
    component: resolve =>
      require(["@/pages/activity/takeFreshVip/qrCodeIndex"], resolve),
    name: "会员推广二维码"
  },
  {
    path: "/VipQrCodePoster/:refereeId", // 会员推广二维码海报
    component: resolve =>
      require(["@/pages/activity/takeFreshVip/qrCode"], resolve),
    name: "会员推广二维码海报"
  },
  {
    path: "/QrCodeStaffLogin", // 会员推广二维码员工登录
    component: resolve =>
      require(["@/pages/activity/takeFreshVip/qrCodeLogin"], resolve),
    name: "会员推广二维码员工登录"
  },
  {
    path: "/FreshVipSignIn", // 会员注册页面
    component: resolve =>
      require(["@/pages/activity/takeFreshVip/signIn"], resolve),
    name: "会员注册"
  },
  {
    path: "/FreshVipSuccess", // 会员注册成功
    component: resolve =>
      require(["@/pages/activity/takeFreshVip/signOk"], resolve),
    name: "会员注册成功"
  },
  {
    path: "/seckillHome",
    component: resolve =>
      require(["@/pages/activity/seckill/seckillHome"], resolve),
    name: "长龙航空"
  },
  {
    path: "/seckillList",
    component: resolve =>
      require(["@/pages/activity/seckill/seckillList"], resolve),
    name: "长龙航空"
  },
  {
    path: "/xfillorder",
    component: resolve => require(["@/pages/order/xfillorder"], resolve),
    name: "长龙航空"
  },
  {
    path: "/checkVipDay", // 校验是不是会员日
    component: resolve =>
      require(["@/pages/activity/seckill/checkVipDay"], resolve),
    name: "长龙航空"
  },
  {
    path: "/check8Year", // 7周年庆祝
    component: resolve =>
      require(["@/pages/activity/yearCelebrate/checkYear"], resolve),
    name: "长龙航空"
  },
  {
    path: "/7thYear", // 7周年庆祝
    component: resolve =>
      require(["@/pages/activity/yearCelebrate/7thYear"], resolve),
    name: "长龙航空"
  },
  {
    path: "/letterIndex", // 春运营销活动-首页
    component: resolve =>
      require(["@/pages/activity/springLetter/index"], resolve),
    meta: { title: "长龙航空" }
  },
  {
    path: "/letterToPay", // 春运营销活动-支付页
    name: "letterToPay",
    component: resolve =>
      require(["@/pages/activity/springLetter/topay"], resolve),
    meta: { title: "长龙航空" }
  },
  {
    path: "/letterPayError", // 春运营销活动-失败支付状态
    component: resolve =>
      require(["@/pages/activity/springLetter/payErr"], resolve),
    meta: { title: "长龙航空" }
  },
  {
    path: "/letterPaySuc", // 春运营销活动-成功支付状态
    component: resolve =>
      require(["@/pages/activity/springLetter/paySuc"], resolve),
    meta: { title: "长龙航空" }
  },
  {
    path: "/letterList", // 春运营销活动-订单列表
    component: resolve =>
      require(["@/pages/activity/springLetter/orderlist"], resolve),
    meta: { title: "长龙航空" }
  },
  {
    path: "/funTravel", // 趣旅行 就长龙
    component: resolve => require(["@/pages/activity/funTravel/index"], resolve)
  },
  {
    path: "/letterWechatPay", // 春运营销活动-订单列表
    component: resolve =>
      require(["@/pages/activity/springLetter/wechatButton"], resolve),
    meta: { title: "长龙航空" }
  },
  {
    path: "/vipDraw/:activityCode", // 会员九宫格抽奖
    name: "vipDraw",
    component: resolve => require(["@/pages/activity/nineDraw/index"], resolve),
    meta: { title: "长龙航空" }
  },
  {
    path: "/vipDraw/addressDraw/:activityCode", // 九宫格邮寄地址
    name: "addressDraw",
    component: resolve =>
      require(["@/pages/activity/nineDraw/address"], resolve),
    meta: { title: "长龙航空" }
  },
  {
    path: "/vipDraw/award/:activityCode", // 九宫格我的奖品
    name: "award",
    component: resolve => require(["@/pages/activity/nineDraw/award"], resolve)
  },
  {
    path: "/activityEntrance", // 活动入口
    component: resolve =>
      require(["@/pages/activity/activityEntrance"], resolve),
    meta: { title: "长龙航空" }
  },
  {
    path: "/goweixin", // 活动入口
    component: resolve => require(["@/pages/activity/goWeiXin"], resolve),
    meta: { title: "长龙航空" }
  },
  // {
  //     path: '/8thYear', // 8周年庆祝
  //     component: resolve => require(['@/pages/activity/yearCelebrate/8thYear'], resolve),
  //     name: '长龙航空'
  // },
  // {
  //     path: '/MembershipDay', // 8周年庆祝-活动2
  //     component: resolve => require(['@/pages/activity/yearEndVipDay/vipDay'], resolve),
  //     name: '长龙航空'
  // },
  // {
  //     path: '/WelcomeToVipDay', // 8周年庆祝-活动入口
  //     component: resolve => require(['@/pages/activity/yearEndVipDay/WelcomeToVipDay'], resolve),
  //     meta: { title: "长龙航空" }
  // },
  // {
  //     path: '/NewYearCoupons', // 2022新年优惠券活动
  //     component: resolve => require(['@/pages/activity/newYearCoupons/index'], resolve),
  //     meta: { title: "长龙航空"}
  // },
  {
    path: "/activitiesMarch", // 2022-3 市场营销活动
    component: resolve =>
      require(["@/pages/activity/activitiesMarch/index"], resolve),
    meta: { title: "长龙航空" }
  },
  {
    path: "/tourismDay1", // 2023-5 中国旅游日活动
    component: resolve =>
      require(["@/pages/activity/activitiesMarch/waituse"], resolve),
    meta: { title: "长龙航空" }
  },
  {
    path: "/tourismDay", // 2023-5 中国旅游日活动
    component: resolve =>
      require(["@/pages/activity/activitiesMarch/index1"], resolve),
    meta: { title: "长龙航空" }
  },
  {
    path: "/memberDay", // 2023-3 会员日活动
    component: resolve =>
      require(["@/pages/activity/memberDay/index"], resolve),
    meta: { title: "长龙航空会员日" }
  },
  {
    path: "/birthday/:name/:date", // 2022-4 生日祝福
    component: resolve => require(["@/pages/activity/birthday/index"], resolve),
    meta: { title: "浙江长龙航空工会祝您生日快乐" }
  },
  {
    path: "/noticeSearch", // 出发到达疫情政策查询
    component: resolve => require(["@/pages/activity/noticeSearch"], resolve),
    meta: { title: "" }
  },
  {
    path: "/secondPage", // 二次跳转
    component: resolve => require(["@/pages/activity/secondPage"], resolve),
    meta: { title: "" }
  },
  {
    path: "/compensationApplication", // 赔付申请（短信链接表单）
    component: resolve =>
      require(["@/pages/activity/SMSLink/compensationApplication"], resolve),
    meta: { title: "赔付申请" }
  },
  {
    path: "/ashOrder",
    component: resolve =>
      require(["@/pages/activity/special/ash/ashServiceOrder"], resolve),
    meta: { title: "骨灰服务订单" }
  },
  {
    path: "/vhOrder",
    component: resolve =>
      require(["@/pages/activity/special/vh/vhServiceOrder"], resolve),
    meta: { title: "视听障碍服务订单" }
  },
  {
    path: "/organOrder",
    component: resolve =>
      require(["@/pages/activity/special/organ/organServiceOrder"], resolve),
    meta: { title: "人体捐献器官服务订单" }
  },
  {
    path: "/organOrderSign",
    component: resolve =>
      require(["@/pages/activity/special/organ/organServiceSign"], resolve),
    meta: { title: "签署确认书" }
  },
  {
    path: "/bloodOrder",
    component: resolve =>
      require(["@/pages/activity/special/blood/bloodServiceOrder"], resolve),
    meta: { title: "血液服务订单" }
  },
  {
    path: "/petOrder",
    component: resolve =>
      require(["@/pages/activity/special/pet/petServiceOrder"], resolve),
    meta: { title: "宠物运输服务订单" }
  },
  {
    path: "/specialCore",
    component: resolve =>
      require(["@/pages/activity/special/core/index"], resolve),
    meta: { title: "特殊旅客中间跳转页" }
  },
  {
    path: "/first",
    component: resolve => require(["@/pages/activity/member/first"], resolve),
    meta: { title: "长龙航空X首享会会员互通" }
  },
  {
    path: "/plusGM",
    component: resolve => require(["@/pages/activity/plusGM"], resolve),
    meta: { title: "长龙航空X古茗" }
  },
  {
    path: "/wheelchair",
    component: resolve =>
      require(["@/pages/activity/special/wheelchair"], resolve),
    meta: { title: "轮椅旅客订单" }
  }
];



// WEBPACK FOOTER //
// ./src/router/modules/activity.js